import { defineComponent as _defineComponent } from 'vue'
import { WalletFundingDetails } from 'ah-api-gateways';
import { useAhWalletsState } from '..';
import { computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletFundingDetailsViewer',
  props: {
    fundingDetails: null
  },
  setup(__props: any) {

const props = __props as {
  fundingDetails: WalletFundingDetails;
};



const walletState = useAhWalletsState();

onMounted(() => walletState.store.useSettingsStore().loadCountries());

const countryName = computed(() => {
  const country = walletState.store
    .useSettingsStore()
    .allCountries.find((c) => c.cc === props.fundingDetails.bankCountry);

  return country?.name ?? '';
});

return { __sfc: true,props, walletState, countryName }
}

})